import React, { useEffect, useRef } from 'react';
import Navigation from '../components/Navigation';
import './FounderPage.css';

const FounderPage = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    // Intersection Observer for fade-in animations
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-active');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    // Observe all elements with observe-fade class
    const elements = document.querySelectorAll('.observe-fade');
    elements.forEach((element) => {
      observerRef.current.observe(element);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="founder-page">
      <Navigation />
      
      <section className="founder-content section-padding">
        <div className="container">
          <div className="founder-layout">
            {/* Portrait */}
            <div className="founder-portrait observe-fade">
              <img 
                src="https://aiwugigdrvijjeoqtpog.supabase.co/storage/v1/object/public/dharma-images/website-tv/anant-swarup-bw.jpeg"
                alt="Anant Swarup - Founder of Tara Ventures"
                className="portrait-image"
              />
            </div>

            {/* Biography */}
            <div className="founder-biography observe-fade">
              <div className="section-label">Founder</div>
              <h1 className="heading-1 founder-name">Anant Swarup</h1>
              
              <div className="biography-text body-large">
                <p>
                  Anant Swarup is the Founder of Tara Ventures.
                </p>
                <p>
                  A 2002 alumnus of <strong>IIT Bombay</strong> (B.Tech Mechanical / M.Tech CIM), Anant began his journey researching Neural Networks and Robotics long before the current AI renaissance.
                </p>
                <p>
                  He spent the next 23 years in global markets, building and running trading businesses across Tokyo, London, and Singapore for <strong>Lehman Brothers</strong> and <strong>Nomura</strong>. Serving as a Managing Director for 13 years, he held leadership roles including Global Head of FX and Emerging Markets Flow Products, navigating complex risk at the highest levels of finance.
                </p>
                <p>
                  Tara Ventures marks his return to deep tech—combining the rigorous risk management of a macro trader with an engineer's drive to build what is useful. Anant is currently building at the intersection of <strong>Deep Tech and Culture</strong>, while also authoring the <em>Conversations in Koyasan</em> literary series.
                </p>
              </div>

              <div className="founder-cta">
                <a 
                  href="https://www.linkedin.com/in/anant-swarup/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary btn-outline"
                >
                  Connect on LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FounderPage;
